import { render, staticRenderFns } from "./StockInfo.vue?vue&type=template&id=04901d46&"
import script from "./StockInfo.vue?vue&type=script&lang=js&"
export * from "./StockInfo.vue?vue&type=script&lang=js&"
import style0 from "./StockInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports